exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-box.style5>i[data-v-b78c188e]{background:#9f4378}.icon-box.style5[data-v-b78c188e]{background:#f5f5f5}.alert.alert-help[data-v-b78c188e]{background:#dcecf6;color:#406f8c}.alert .close[data-v-b78c188e],.info-box .close[data-v-b78c188e]{color:#406f8c}.icon-check-srvcs[data-v-b78c188e]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check-srvcs[data-v-b78c188e]:after{content:\"\";position:absolute;top:0;right:0;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #827e7f}.errormsg[data-v-b78c188e]{margin-bottom:3px;margin-top:3px;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b78c188e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/forms/BookingnoTab.vue
// module id = 392
// module chunks = 0